import React from 'react'
import { Container, Panel } from 'rsuite'
import { useTranslation } from "react-i18next"
import LanguageSwitcher from '@client/components/LanguageSwitcher'


export default function Help() {
    const { t } = useTranslation();

    return (
        <Container>
            <Panel bordered header={t('Help')}>
                {t('Help not implemented yet.')}
            </Panel>
        </Container>
    )
}